<app-navbar-primary />

<main class="bg-body-secondary">
  <div class="d-flex justify-content-center align-items-center h-100">
    <div class="card overflow-auto" style="width: 34rem; height: 34rem">
      <div class="card-body">
        <button class="btn p-0 mb-3" routerLink="/">
          <img src="/assets/icons/arrow_left_short.svg" alt="" />
          <span class="text-body-secondary">Volver</span>
        </button>

        <h4>{{ title }}</h4>

        @if (loading) {
          <div class="text-center py-3">
            <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
          </div>
        } @else if (error) {
          <p class="text-body-secondary">
            No se pudo cargar el contenido. Intenta más tarde.
          </p>
        } @else {
          <div [innerHTML]="content"></div>
        }
      </div>
    </div>
  </div>
</main>

<app-footer-primary />
